/**
 * Settings API functions.
 */
import apiClient from './client';

export interface SettingsResponse {
  app_name: string;
  color_scheme: string;
  signup_enabled: boolean;
  signup_requires_approval: boolean;
  oauth2_signup_requires_approval: boolean;
  oauth2_provider?: string | null;
  oauth2_client_id?: string | null;
  oauth2_client_secret?: string | null;
  oauth2_authorization_url?: string | null;
  oauth2_token_url?: string | null;
  oauth2_userinfo_url?: string | null;
  oauth2_scope?: string | null;
  oauth2_redirect_uri?: string | null;
  oauth2_cilogon_default_idp?: string | null;
  oauth2_cilogon_idp_list?: string | null;
  openstack_cache_refresh_interval_hours?: number;
  openstack_reject_password_auth?: boolean;
  openstack_allowed_urls?: string | null;
  kubernetes_cluster_detection_enabled?: boolean;
  kubernetes_controlplane_patterns?: string | null;
  kubernetes_worker_patterns?: string | null;
}

export interface SettingsUpdate {
  app_name?: string;
  color_scheme?: string;
  signup_enabled?: boolean;
  signup_requires_approval?: boolean;
  oauth2_signup_requires_approval?: boolean;
  oauth2_provider?: string | null;
  oauth2_client_id?: string | null;
  oauth2_client_secret?: string | null;
  oauth2_authorization_url?: string | null;
  oauth2_token_url?: string | null;
  oauth2_userinfo_url?: string | null;
  oauth2_scope?: string | null;
  oauth2_redirect_uri?: string | null;
  oauth2_cilogon_default_idp?: string | null;
  oauth2_cilogon_idp_list?: string | null;
  openstack_cache_refresh_interval_hours?: number;
  openstack_reject_password_auth?: boolean;
  openstack_allowed_urls?: string | null;
  kubernetes_cluster_detection_enabled?: boolean;
  kubernetes_controlplane_patterns?: string | null;
  kubernetes_worker_patterns?: string | null;
}

/**
 * Get current application settings.
 */
export const getSettings = async (): Promise<SettingsResponse> => {
  const response = await apiClient.get<SettingsResponse>('/api/settings');
  return response.data;
};

/**
 * Update application settings (admin only).
 * Includes CSRF token for state-changing operation.
 */
export const updateSettings = async (settings: SettingsUpdate): Promise<SettingsResponse> => {
  // Include CSRF token in request
  const { getCsrfHeader } = await import('./csrf');
  const csrfHeaders = await getCsrfHeader();
  
  const response = await apiClient.put<SettingsResponse>(
    '/api/settings',
    settings,
    {
      headers: csrfHeaders,
    }
  );
  return response.data;
};

